import {
  IResponseBiometricParameters,
  IResponseBiometricsNurseries,
  IResponseHealthMortality,
  IResponseNurseryMortality,
  IResponseQualityParameters,
  IResponseSupply,
  IResponseWaterAnalysisNurseries,
} from 'v2/resources/types/graphics';

export const DEFAULT_RESPONSE_SUPPLY: IResponseSupply = {
  data: [
    {
      pond: 'ERROR',
      ERROR: 'ERROR',
    },
  ],
  labels: ['ERROR'],
};
export const DEFAULT_RESPONSE_NURSERY_MORTALITY: IResponseNurseryMortality[] = [
  {
    pond_id: 0,
    pond_name: '',
    cycle_code_id: 0,
    cycle_id: 0,
    mortalities: 0,
    mortalities_percentage: 0,
  },
];
export const DEFAULT_RESPONSE_HEALTH_MORTALITY: IResponseHealthMortality = {
  info: [
    {
      data: [
        {
          date: 'ERROR',
          filter: 'ERROR',
          value: 0,
        },
      ],
      name: 'ERROR',
    },
  ],
  labels: ['ERROR'],
};
export const DEFAULT_RESPONSE_QUALITY_PARAMETERS: IResponseQualityParameters = {
  info: [
    {
      data: [
        {
          date: 'ERROR',
          filter: 'ERROR',
          value: 0,
        },
      ],
      name: 'ERROR',
    },
  ],
  labels: ['ERROR'],
};
export const DEFAULT_RESPONSE_BIOMETRICS_PARAMETERS: IResponseBiometricParameters =
  {
    info: [
      {
        data: [
          {
            date: 'ERROR',
            filter: 'ERROR',
            value: 0,
          },
        ],
        name: 'ERROR',
      },
    ],
    labels: ['ERROR'],
  };
export const DEFAULT_RESPONSE_BIOMETRICS_NURSERIES: IResponseBiometricsNurseries =
  {
    info: [
      {
        data: [
          {
            date: 'ERROR',
            filter: 'ERROR',
            value: 0,
          },
        ],
        name: 'ERROR',
      },
    ],
    labels: ['ERROR'],
  };
export const DEFAULT_RESPONSE_WATER_ANALYSIS_NURSERIES: IResponseWaterAnalysisNurseries =
  {
    info: [
      {
        data: [
          {
            date: 'ERROR',
            filter: 'ERROR',
            value: 0,
          },
        ],
        name: 'ERROR',
      },
    ],
    labels: ['ERROR'],
  };
